import React from 'react'
import { configureStore } from "@reduxjs/toolkit"
import AdvanceSearchReducer from './AdvanceSearchSlice';

const Store = configureStore({
    reducer: {
        advSearch: AdvanceSearchReducer
    }
})
export default Store
